import { breakpoint, Heading1 } from '@cmctechnology/phoenix-stockbroking-web-design';
import { css } from 'styled-components';

export const mobileCardHeaderHeading1FontCss = css`
  @media (max-width: ${breakpoint.mobile}) {
    ${Heading1} {
    font-size: 1.75rem;
  }
`;
